export const API_ENDPOINTS = {
    // Auth endpoints
    firstLoginReset: '/auth/first-login-reset',
    login: '/auth/login',
    logout: '/auth/logout',
    refreshToken: '/auth/refresh-token',
    
    // Chat endpoints
    smartDocs: '/apiv2/smart_docs',
    chatMessages: '/apiv2/chat/messages',
    chatFeedback: '/apiv2/chat/feedback',
    chatHeaders: '/apiv2/chat/get_chat_headers',
    
    // Focus360 endpoint
    insights: '/apiv2/insights',
    usage: '/apiv2/usage/',
    
    // Energy optimization endpoint
    energyOptimization: '/apiv2/energy_opinsights',
    
    // Dynamic endpoints (require application_id)
    categories: (applicationId) => `/apiv2/${applicationId}/categories_with_subcategories`,
    
    // Citations endpoint
    citations: (chatId, userId, pairId) => `/apiv2/smart_docs/citations/${chatId}/${userId}/${pairId}`,
  
    generatePDF: '/generate-pdf',

    applications: '/apiv2/applications',
  };
  